import ApplicationSerializer from 'eflex/serializers/application';

export default class HardwareSerializer extends ApplicationSerializer {
  attrs = {
    station: {
      deserialize: false,
      serialize: false,
    },
  };
}
